import { render, staticRenderFns } from "./LoanView.vue?vue&type=template&id=a4542290&style=background-color%3A%20%2383cae830%3B"
import script from "./LoanView.vue?vue&type=script&lang=js"
export * from "./LoanView.vue?vue&type=script&lang=js"
import style0 from "./LoanView.vue?vue&type=style&index=0&id=a4542290&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports